


$(document).ready(function () {
    /// testimoinals slider
    $('.ft-slider-1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: false,
        asNavFor: '.ft-slider-2',
        adaptiveHeight:true
    });
    $('.ft-slider-2').slick({
        slidesToShow: 1,
        adaptiveHeight:false,
        slidesToScroll: 1,
        asNavFor: '.ft-slider-1',
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        arrows: false,
        focusOnSelect: false
    });

  ///testimonials slider content read more
    var showChar = 500;
	var ellipsestext = "..";
	var moretext = "Read more";
	var lesstext = "Read less";
	$('.ft-testimonials-content-item .ftparg').each(function() {
		var content = $(this).text();

		if(content.length > showChar) {
            //alert('in');
			var c = content.substr(0, showChar);
			var h = content.substr(showChar-1, content.length - showChar);

            //console.log(c);
            //console.log(h);
            var html = c + '<span class="moreelipses">'+ellipsestext+'</span>&nbsp;<span class="morecontent"><span class="hide" style="display:none;">' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink less">'+moretext+'</a></span>';
            //console.log(html);
			$(this).html(html);
		}

	});

	$(".morelink").click(function(){
		if($(this).hasClass("less")) {
			$(this).removeClass("less");
			$(this).html(lesstext);
		} else {
			$(this).addClass("less");
			$(this).html(moretext);
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});



  ////// product slider
  $('.ft-productbig-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight:true,
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite:false,
        asNavFor: '.ft-product-thumb-slider'
    });
    $('.ft-product-thumb-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.ft-productbig-slider',
        dots: false,
        arrows: true,
        infinite:false,
        focusOnSelect: true,
        prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></button>'
    });

    $('.nmi-version .header-top-bar').slick({
        mobileFirst: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></button>',
        responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 992,
              settings: {
                autoplay: true,
                autoplaySpeed: 3200,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                dots: false,
              }
            }
          ]
    });


    $('.ft_radio-wrapper input').on('change', function() {
        var ftSelectedVarient = $(this).val();
        var ftForForm = $(this).data('option-input');
        var ftFormID= 'product-form-'+ftForForm;
        var ftproductJson=JSON.parse($('#' + ftFormID).find('[data-ftproduct-json]').text())
        //console.log(ftproductJson);
        //onsole.log(ftSelectedVarient);
        
        //product-select-5313298432156_p_nd_sec1
        var SelectedftVar =_getVariantFromOptions(ftproductJson,ftSelectedVarient);
        //console.log($("#product-select-" + ftForForm + " option[value=" + SelectedftVar.id + "]"));
        
        
        var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant='+SelectedftVar.id;    
        window.history.pushState({ path: refresh }, '', refresh);

        $("#product-select-" + ftForForm + " option:selected").prop("selected",false);
        $("#product-select-" + ftForForm + " option[value=" + SelectedftVar.id + "]").prop("selected",true);

        ///updatin price
        $.each($('.ft-has-price'), function () {
            //var ftoldPrice=  SelectedftVar.price+3000;
            $('.money',this).html(Shopify.formatMoney(SelectedftVar.price, Theme.moneyFormat));
            //$(this).find('.overline-price').text(Shopify.formatMoney(ftoldPrice, Theme.moneyFormat));
            $(this).find('.overline-price').text(Shopify.formatMoney(SelectedftVar.compare_at_price, Theme.moneyFormat));
        });
    });

    /// setup BUY NOW button logic
    $('form').on('click','.ft-shop-buttons .ftbuynowbtn', function (e) {
        e.preventDefault();
        var formID=$(this).data('ftforform');
        $.ajax({
            type: 'POST', 
            url: window.Shopify.routes.root + 'cart/add.js',
            dataType: 'json', 
            data:$('#'+formID).serialize(),
            success: function (data) {
                //console.log(data);
                document.location.href = '/cart/checkout';
              },
            error: function (data) {
                console.log({'fail':data});
              }
         });
        if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
            BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
            BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
        }
    });

    //////////
    /// setup BUY NOW button with NO Redirect + show cart button
    $('form').on('click','.ft-addtocart .ftaddtocartbtn', function (e) {
        e.preventDefault();
        var formID=$(this).data('ftforform');
        $(this).parents('.ft-addtocart').addClass('ftproduct-beingadded');
        $.ajax({
            type: 'POST', 
            url: window.Shopify.routes.root + 'cart/add.js',
            dataType: 'json', 
            context: this,
            data:$('#'+formID).serialize(),
            success: function (data) {
                //console.log(data);
                $(this).parents('.ft-addtocart').removeClass('ftproduct-beingadded');
                $(this).parents('.ft-addtocart').addClass('ftproduct-added');
                Shopify.getCart(function (cart) {
                    return $('.cart-link .cart-count').text(cart.item_count);
                  });
              },
            error: function (data) {
                console.log({'fail':data});
              }
         });
         
    });

    ////custom video popup
    /// display
    
    $('body').on('click','.ftpopvideoplay', function () {
        var videourl= $(this).data('videolink');
        $('#ftpop-player').attr('src',videourl);

        $('.ftpopup').css('display','flex').addClass('visible');
        var ftPopupPlayer = new Vimeo.Player($('#ftpop-player'));
        ///ftPopupPlayer.loadVideo(videourl);
        ftPopupPlayer.ready().then(function() {
            ftPopupPlayer.play();
        });
    });
    ///close popup
    $('body').on('click','.ftpopclose', function () {
        var ftPopupPlayer2 = new Vimeo.Player($('#ftpop-player'));
        ftPopupPlayer2.unload();
        $('#ftpop-player').attr('src','');
        $('.ftpopup').removeClass('visible').css('display','none');
    });

    $('.start_ft_popup_play').magnificPopup({
        type:'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      });

});

function _getVariantFromOptions(ftproductJSON,productOption) {
    if (ftproductJSON.variants == null) {
      return;
    }
    var foundVariant = null;
    ftproductJSON.variants.forEach(function (variant) {
      if (productOption === variant.title) {
        foundVariant = variant;
      }
    });
    return foundVariant;
}



jQuery(document).ready(function() {
    var ft_offset = 700;
    var ft_duration = 1000;
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > ft_offset) {
            jQuery('button.ft-gotop').css('opacity',1);
        } else {
            jQuery('button.ft-gotop').css('opacity',0);
        }
    });
    
    jQuery('button.ft-gotop').click(function(event) {
        event.preventDefault();
        jQuery('html, body').animate({scrollTop: 0}, ft_duration);
        return false;
    })
});